import { Styles } from '@monkvision/types';

export const styles: Styles = {
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#000000',
  },
  cameraPreview: {
    width: '100%',
    height: '100%',
  },
  cameraCanvas: {
    display: 'none',
  },
};
